module.exports = __webpack_public_path__ + "static/media/conf-app2.25e850d5.png";